import { IconName } from '../Components/UI';

export const DEFAULT_ICON_NAME = 'menuContexto';

export const defaultDisciplineIcons: IconName[] = [
  'disciplinaArquitetura',
  'disciplinaEstrutura',
  'disciplinaEletrica',
  'disciplinaHidrossanitaria',
  'disciplinaMecanica',
  'disciplinaFundacao',
  'disciplinaAr',
  'disciplinaIncendio',
  'menuContexto',
];

export const genericPickerIcons: IconName[] = [
  'airConditioning',
  'alertTriangle',
  'armchair',
  'ballFootball',
  'barbell',
  'barrierBlock',
  'bathtub',
  'biohazard',
  'brickWall',
  'brush',
  'buildingBroadcastTower',
  'buildingFactory',
  'buildingScryscraper',
  'buildingWarehouse',
  'bulb',
  'calculator',
  'camera2',
  'car',
  'carBattery',
  'checkupList',
  'cloudRain',
  'coffee',
  'coinsMoney',
  'colorSwatch',
  'crane',
  'dog',
  'door',
  'elevator',
  'faceId',
  'fence',
  'fingerprint',
  'fireHydrant',
  'flower',
  'geometry',
  'graduationCap',
  'hammer',
  'headset',
  'hotelService',
  'idBadge',
  'jacket',
  'key2',
  'lamp',
  'lockAccess',
  'map',
  'mapPin',
  'mapSearch',
  'package',
  'paint',
  'paw',
  'plant',
  'plug',
  'plugConnect',
  'pool',
  'propeller',
  'radioactive',
  'recycle',
  'road',
  'snowflake',
  'solarPanel',
  'solarPanel2',
  'stairs',
  'temperature',
  'temperatureMinus',
  'temperaturePlus',
  'tools',
  'trafficeCone',
  'trees',
  'truckDelivery',
  'truckLoading',
  'umbrella',
  'urgent',
  'wind',
  'wreckingBall',
];

export const iconSearchTerms: Partial<Record<IconName, string[]>> = {
  disciplinaArquitetura: ['arquitetura', 'architecture'],
  disciplinaEstrutura: ['estrutura', 'structure', 'structural'],
  disciplinaEletrica: ['eletrica', 'instalacoes eletricas', 'electrical', 'electric'],
  disciplinaHidrossanitaria: ['hidrossanitaria', 'hidraulica', 'sanitario', 'plumbing', 'hydraulic'],
  disciplinaMecanica: ['mecanica', 'instalacoes mecanicas', 'mechanical'],
  disciplinaFundacao: ['fundacao', 'fundacoes', 'foundation'],
  disciplinaAr: ['ar condicionado', 'climatizacao', 'air conditioning', 'hvac'],
  disciplinaIncendio: ['incendio', 'combate a incendio', 'fire', 'fire safety'],
  menuContexto: ['generico', 'outro', 'outros', 'personalizado', 'generic', 'other', 'custom'],

  airConditioning: ['ar condicionado', 'climatizacao', 'air conditioning', 'hvac', 'ac'],
  alertTriangle: ['alerta', 'atencao', 'aviso', 'triangulo', 'alert', 'warning', 'triangle'],
  armchair: ['poltrona', 'sofa', 'cadeira', 'armchair', 'chair'],
  ballFootball: ['bola', 'futebol', 'ball', 'football', 'soccer'],
  barbell: ['halter', 'peso', 'academia', 'barbell', 'gym', 'weight', 'dumbbell'],
  barrierBlock: ['barreira', 'bloqueio', 'obstaculo', 'barrier', 'block'],
  bathtub: ['banheira', 'banheiro', 'bathtub', 'bath'],
  biohazard: ['biologico', 'risco biologico', 'perigo', 'biohazard', 'hazard'],
  brickWall: ['parede', 'tijolo', 'alvenaria', 'muro', 'brick', 'wall'],
  brush: ['pincel', 'pintura', 'brush', 'paint brush'],
  buildingBroadcastTower: ['torre', 'antena', 'transmissao', 'tower', 'broadcast', 'antenna', 'radio'],
  buildingFactory: ['fabrica', 'industria', 'factory', 'industry', 'industrial'],
  buildingScryscraper: ['predio', 'arranha-ceu', 'edificio', 'skyscraper', 'building'],
  buildingWarehouse: ['galpao', 'armazem', 'deposito', 'warehouse', 'storage'],
  bulb: ['lampada', 'luz', 'ideia', 'bulb', 'light', 'idea'],
  calculator: ['calculadora', 'calculo', 'calculator', 'calculation', 'math'],
  camera2: ['camera', 'foto', 'camera', 'photo', 'picture'],
  car: ['carro', 'veiculo', 'automovel', 'car', 'vehicle', 'auto'],
  carBattery: ['bateria', 'battery', 'car battery'],
  checkupList: ['lista', 'checklist', 'verificacao', 'list', 'check', 'checkup'],
  cloudRain: ['nuvem', 'chuva', 'clima', 'cloud', 'rain', 'weather'],
  coffee: ['cafe', 'xicara', 'coffee', 'cup'],
  coinsMoney: ['dinheiro', 'moeda', 'financeiro', 'money', 'coins', 'cash'],
  colorSwatch: ['cor', 'paleta', 'amostra', 'color', 'swatch', 'palette'],
  crane: ['guindaste', 'grua', 'construcao', 'crane', 'construction'],
  dog: ['cachorro', 'cao', 'pet', 'animal', 'dog'],
  door: ['porta', 'entrada', 'door', 'entrance'],
  elevator: ['elevador', 'elevator', 'lift'],
  faceId: ['reconhecimento facial', 'rosto', 'biometria', 'face id', 'face', 'biometric'],
  fence: ['cerca', 'grade', 'fence'],
  fingerprint: ['digital', 'impressao digital', 'biometria', 'fingerprint', 'biometric'],
  fireHydrant: ['hidrante', 'incendio', 'fire hydrant', 'fire', 'hydrant'],
  flower: ['flor', 'jardim', 'flower', 'garden', 'plant'],
  geometry: ['geometria', 'regua', 'esquadro', 'geometry', 'ruler'],
  graduationCap: ['formatura', 'educacao', 'capelo', 'graduation', 'education', 'school'],
  hammer: ['martelo', 'ferramenta', 'hammer', 'tool'],
  headset: ['fone', 'atendimento', 'suporte', 'headset', 'headphone', 'support'],
  hotelService: ['hotel', 'servico', 'sino', 'hotel', 'service', 'bell'],
  idBadge: ['cracha', 'identidade', 'id', 'badge', 'identification'],
  jacket: ['jaqueta', 'casaco', 'jacket', 'coat'],
  key2: ['chave', 'acesso', 'key', 'access'],
  lamp: ['luminaria', 'lampada', 'abajur', 'lamp', 'light'],
  lockAccess: ['cadeado', 'acesso', 'seguranca', 'lock', 'access', 'security'],
  map: ['mapa', 'localizacao', 'map', 'location'],
  mapPin: ['pino', 'localizacao', 'marcador', 'map pin', 'location', 'pin'],
  mapSearch: ['buscar local', 'pesquisar mapa', 'map search', 'search location'],
  package: ['pacote', 'caixa', 'encomenda', 'package', 'box', 'delivery'],
  paint: ['tinta', 'pintura', 'paint', 'painting'],
  paw: ['pata', 'animal', 'pet', 'paw', 'animal print'],
  plant: ['planta', 'vaso', 'jardim', 'plant', 'garden'],
  plug: ['tomada', 'energia', 'plug', 'power', 'outlet'],
  plugConnect: ['conexao', 'conectar', 'plug connect', 'connect', 'connection'],
  pool: ['piscina', 'pool', 'swimming'],
  propeller: ['helice', 'ventilador', 'propeller', 'fan'],
  radioactive: ['radioativo', 'radiacao', 'perigo', 'radioactive', 'radiation', 'hazard'],
  recycle: ['reciclagem', 'reciclar', 'recycle', 'recycling'],
  road: ['estrada', 'rua', 'via', 'road', 'street'],
  snowflake: ['neve', 'frio', 'floco de neve', 'snowflake', 'snow', 'cold'],
  solarPanel: ['painel solar', 'energia solar', 'solar panel', 'solar', 'energy'],
  solarPanel2: ['painel solar', 'energia solar', 'solar panel', 'solar', 'energy'],
  stairs: ['escada', 'degraus', 'stairs', 'steps'],
  temperature: ['temperatura', 'termometro', 'temperature', 'thermometer'],
  temperatureMinus: ['temperatura baixa', 'frio', 'diminuir temperatura', 'temperature minus', 'cold', 'decrease'],
  temperaturePlus: ['temperatura alta', 'quente', 'aumentar temperatura', 'temperature plus', 'hot', 'increase'],
  tools: ['ferramentas', 'manutencao', 'chave inglesa', 'tools', 'maintenance', 'wrench'],
  trafficeCone: ['cone', 'transito', 'obra', 'traffic cone', 'cone', 'construction'],
  trees: ['arvores', 'floresta', 'natureza', 'trees', 'forest', 'nature'],
  truckDelivery: ['caminhao', 'entrega', 'truck', 'delivery'],
  truckLoading: ['caminhao', 'carga', 'truck loading', 'loading', 'cargo'],
  umbrella: ['guarda-chuva', 'chuva', 'umbrella', 'rain'],
  urgent: ['urgente', 'emergencia', 'urgent', 'emergency'],
  wind: ['vento', 'ventilacao', 'wind', 'ventilation'],
  wreckingBall: ['bola de demolicao', 'demolicao', 'wrecking ball', 'demolition'],
};

export const resolveCustomDisciplineIcon = (icon?: string | null): IconName => {
  if (!icon || icon === 'default') {
    return DEFAULT_ICON_NAME;
  }

  return icon as IconName;
};

export const disciplineIcons = new Map<string, IconName>([
  ['maleta-icons icon-ic-disciplina-architeture', 'disciplinaArquitetura'],
  ['maleta-icons icon-ic-disciplina-block', 'disciplinaEstrutura'],
  ['maleta-icons icon-ic-disciplina-energy', 'disciplinaEletrica'],
  ['maleta-icons icon-ic-disciplina-hidro', 'disciplinaHidrossanitaria'],
  ['maleta-icons icon-ic-disciplina-mec', 'disciplinaMecanica'],
  ['maleta-icons icon-ic-disciplina-foundation', 'disciplinaFundacao'],
  ['maleta-icons icon-ic-disciplina-cold', 'diciplinaAr'],
  ['maleta-icons icon-ic-disciplina-fire', 'disciplinaIncendio'],
  ['maleta-icons icon-ic-disciplina-custom', 'menuContexto'],
  ['menuContexto', 'menuContexto'],
]);

export const iconFileByExtension = (extension: string): IconName => {
  switch (extension.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'tif':
    case 'bmp':
    case 'webp':
    case 'gif':
    case 'svg':
      return 'arquivoImg';
    case 'rvt':
    case 'dwf':
    case 'dwfx':
    case 'rcp':
    case 'nwc':
    case 'nwd':
    case 'ifc':
      return 'arquivo3d';
    case 'dgn':
    case 'dxf':
    case 'dwg':
      return 'arquivo2d';
    case 'xls':
    case 'xlsx':
    case 'gsheet':
      return 'arquivoExcel';
    case 'pdf':
      return 'arquivoPdf';
    case 'txt':
    case 'docx':
    case 'doc':
    case 'odt':
    case 'gdoc':
    case 'gslides':
    case 'pptx':
    case 'ppt':
      return 'arquivoTxt';
    default:
      return 'arquivoTxt';
  }
};

export const iconFileByFilename = (filename: string) => {
  const split = filename.split('.');
  const extension = split[split.length - 1];
  return iconFileByExtension(extension);
};
